export default {
  //数据库名
  mydbname: 'tts',
  //数据库版本
  myversion: 1,
  dbok: 0,
  //打开或创建数据库
  dbstar() {
    const conn = window.indexedDB.open(this.mydbname, this.myversion);
    conn.onsuccess = function(event) {
      var db = event.target.result;
    }
    conn.onupgradeneeded = function(event) {
      var db = event.target.result;

      if (!db.objectStoreNames.contains('user')) {
        var st = db.createObjectStore('user', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('phone', 'phone', {
          unique: true
        });
      }

      if (!db.objectStoreNames.contains('registered_tip')) {
        var st = db.createObjectStore('registered_tip', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('id', 'id', {
          unique: true
        });
      }
      if (!db.objectStoreNames.contains('allStorePermissionsList')) {
        var st = db.createObjectStore('allStorePermissionsList', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('id', 'id', {
          unique: true
        });
      }
      if (!db.objectStoreNames.contains('storeItem')) {
        var st = db.createObjectStore('storeItem', {
          keyPath: 'itemId',
          autoIncrement: true
        });
        st.createIndex('itemId', 'itemId', {
          unique: true
        });
      }
      if (!db.objectStoreNames.contains('store')) {
        var st = db.createObjectStore('store', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('userId', 'userId', {
          unique: true
        });

        if (!db.objectStoreNames.contains('typeList')) {
          var st = db.createObjectStore('typeList', {
            keyPath: 'firstTypeId',
            autoIncrement: true
          });
          st.createIndex('firstTypeId', 'firstTypeId', {
            unique: true
          });
        }
      }
      if (!db.objectStoreNames.contains('myTypeList')) {
        var st = db.createObjectStore('myTypeList', {
          keyPath: 'typeId',
          autoIncrement: true
        });
        st.createIndex('storeId', 'storeId', {
          unique: false
        });
        st.createIndex('typeName', 'typeName', {
          unique: true
        });
      }
      //首页会员信息
      if (!db.objectStoreNames.contains('indexStoreMessage')) {
        var st = db.createObjectStore('indexStoreMessage', {
          keyPath: 'id',
          autoIncrement: true
        });
      }
      //展会首页图片
      if (!db.objectStoreNames.contains('storeArr')) {
        var st = db.createObjectStore('storeArr', {
          keyPath: 'userId',
          autoIncrement: true
        });
        st.createIndex('storeId', 'storeId', {
          unique: true
        });
      }

      //-----------------产品表开始-------------------------
      //所有产品
      if (!db.objectStoreNames.contains('productsAll')) {
        var st = db.createObjectStore('productsAll', {
          keyPath: 'id',
          autoIncrement: true
        });
        // st.createIndex('productId', 'productId', { unique: true });
      }

      if (!db.objectStoreNames.contains('pImgFiles')) {
        var st = db.createObjectStore('pImgFiles', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('productId', 'productId', {
          unique: false
        });
      }
      //产品视频对象表
      if (!db.objectStoreNames.contains('pVideoFiles')) {
        var st = db.createObjectStore('pVideoFiles', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('productId', 'productId', {
          unique: false
        });
      }
      if (!db.objectStoreNames.contains('pAreaImgFiles')) {
        var st = db.createObjectStore('pAreaImgFiles', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('productId', 'productId', {
          unique: false
        });
      }
      if (!db.objectStoreNames.contains('productCover')) {
        var st = db.createObjectStore('productCover', {
          keyPath: 'id',
          autoIncrement: true
        });
        st.createIndex('productId', 'productId', {
          unique: false
        });
      }
      //编辑等上传产品
      if (!db.objectStoreNames.contains('productDetailS')) {
        var st = db.createObjectStore('productDetailS', {
          keyPath: 'productId',
          autoIncrement: true
        });
        st.createIndex('productId', 'productId', {
          unique: true
        });
      }

    }
  },
  //初始化数据库
  conn() {
    return new Promise((resolve, reject) => {
      const connection = window.indexedDB.open(this.mydbname, this.myversion)
      connection.onsuccess = function(event) {
        resolve(event.target.result)
      }
    })
  },

  //封装 新增, 读取, 读取所有 方法
  async dbOperation(st, type, data) {

    let typeList = ['add', 'get', 'getAll']
    if (!typeList.includes(type)) {
      throw new Error(`操作类型错误, 仅支持: ${typeList.toString()} 方法`)
    }
    const readType = type === 'add' ? 'readwrite' : 'readonly'

    const res = await this.conn()
    const objectStore = res.transaction(st, readType).objectStore(st)
    const response = new Promise((resolve, reject) => {
      const request = objectStore[type](data)
      request.onsuccess = (res) => {
        resolve(res.target.result)
      }
      request.onerror = (err) => {
        reject(err)
      }
    })
    return response
  },
  // ('pAreaImgFiles','productId',v.productId);
  //读取索引方法
  async getindex(st, index, data) {

    const res = await this.conn()
    const objectStore = res.transaction(st, 'readwrite').objectStore(st)
    const response = new Promise((resolve, reject) => {
      const request = objectStore.index(index).getAll(data);
      request.onsuccess = (res) => {
        resolve(res.target.result)
      }
      request.onerror = (err) => {
        reject(err)
      }
    })
    return response
  },

  async delindex(st, data) {

    const res = await this.conn()
    const objectStore = res.transaction(st, 'readwrite').objectStore(st)
    const response = new Promise((resolve, reject) => {
      const request = objectStore.delete(data);
      request.onsuccess = (res) => {
        resolve(res.target.result)
      }
      request.onerror = (err) => {
        reject(err)
      }
    })
    return response
  },

  //更新数据
  update(st, dat) {
    //打开数据库拿到数据库实例db
    const conn = window.indexedDB.open(this.mydbname, this.myversion);
    conn.onsuccess = function(event) {
      var db = event.target.result;
      //必须指定表格名称和操作模式（"只读readonly"或"读写"readwrite"）
      var request = db.transaction([st], 'readwrite').objectStore(st).put(dat);

      request.onsuccess = function(event) {
        console.log('数据更新成功');
      };

      request.onerror = function(event) {
        console.log('数据更新失败');
      }

    }
  },
  //更新数据
  udataindex(st, index, dat) {
    //打开数据库拿到数据库实例db
    const conn = window.indexedDB.open(this.mydbname, this.myversion);
    conn.onsuccess = function(event) {
      var db = event.target.result;
      //必须指定表格名称和操作模式（"只读readonly"或"读写"readwrite"）
      var request = db.transaction([st], 'readwrite').objectStore(st).index(index).put(dat);


      request.onsuccess = function(event) {
        console.log('数据更新成功');
      };

      request.onerror = function(event) {
        console.log('数据更新失败');
      }

    }
  },

  del(st, dat) {
    //打开数据库拿到数据库实例db
    const conn = window.indexedDB.open(this.mydbname, this.myversion);
    conn.onsuccess = function(event) {
      var db = event.target.result;
      //必须指定表格名称和操作模式（"只读readonly"或"读写"readwrite"）
      var request = db.transaction([st], 'readwrite').objectStore(st).delete(dat);

      request.onsuccess = function(event) {
        console.log('删除成功');
      };

      request.onerror = function(event) {
        console.log('删除失败');
      }
    }
  },
  /*
  //初始化数据库
  dbInit () {
    return new Promise((resolve, reject) => {
      const connection = window.indexedDB.open('dbname', 2)
      connection.onsuccess = function (event) {
        resolve(event.target.result)
      }
      connection.onupgradeneeded = function (event) {
        const db = event.target.result
        if (!db.objectStoreNames.contains('person')) {
          db.createObjectStore('person', { autoIncrement: true })
        }
      }
      connection.onerror = function (err) {
        reject(err)
      }
    })
  },

  //封装 新增, 读取, 读取所有 方法
  async dbOperation (type, data) {
    let typeList = ['add', 'get', 'getAll']
    if (!typeList.includes(type)) {
      throw new Error(`操作类型错误, 仅支持: ${typeList.toString()} 方法`)
    }
    const readType = type === 'add' ? 'readwrite' : 'readonly'
    const res = await this.dbInit()
    const objectStore = res.transaction('person', readType).objectStore('person')
    const response = new Promise((resolve, reject) => {
      const request = objectStore[type](data)
      request.onsuccess = (res) => {
        resolve(res.target.result)
      }
      request.onerror = (err) => {
        reject(err)
      }
    })
    return response
  },

  //函数调用
    async add () {
        const data = {
            name: 'name',
            age: 'age',
            email: 'email@11.11'
        }
        const res = await this.dbOperation('add', data)
        console.log(res)
        },

    async read () {
        const res = await this.dbOperation('get', 1)
        console.log(res)
        },

    async readAll () {
        const res = await this.dbOperation('getAll')
        console.log(res)
        },
    */
}



// WEBPACK FOOTER //
// ./src/indexedDB.js